import React from "react";
import { useTranslation } from "react-i18next";

import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";

import Button from "../Button";
import { Autocomplete, AutocompleteMulti } from "../Autocomplete";

const RolesTreeForm = ({ roles, permissions, selectedRole, selectedPermissions, onChange, onSave, onReset, error }) => {
  const { t } = useTranslation();
  return (
    <Paper variant="outlined" style={{ marginBottom: "2rem", padding: "1rem" }}>
      <Box
        sx={{
          mb: "1rem",
          display: "flex",
        }}
      >
        <Box
          sx={{
            width: "50%",
            mr: 1,
          }}
        >
          <Autocomplete
            onChange={(item, reason) => onChange("role", item, reason)}
            value={selectedRole}
            options={roles || []}
            label={t("role.select")}
          />
        </Box>
        <Box
          sx={{
            width: "50%",
          }}
        >
          <AutocompleteMulti
            onChange={(item, reason) => onChange("permissions", item, reason)}
            value={selectedPermissions || []}
            options={permissions || []}
            label={t("permission.select")}
          />
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Button onClick={onSave}>{t("add")}</Button>
        {selectedRole && selectedPermissions && selectedRole.crewId ? (
          <Button onClick={() => onReset(selectedRole)}>{t("reset_to_defaults")}</Button>
        ) : null}
      </Box>
      {error ? <Typography color="error">{error}</Typography> : null}
    </Paper>
  );
};

export default RolesTreeForm;
